import * as $ from 'jquery';

import * as Pikaday from 'pikaday-time';
import { PikadayOptions } from 'pikaday-time';

export default class DatePicker {
	private picker: Pikaday;

	constructor() {
		this.initDatePicker();
		$(document).on('jsfAjaxAlways', this.initDatePicker);
	}

	private initDatePicker = () => {
		this.picker = new Pikaday({
			field: document.getElementById('appointments\:apptDate'),
			showTime: false,
			format: 'MMM DD YYYY',
			disableDayFn: (date: Date): boolean => {
				// https://stackoverflow.com/questions/36716796/want-to-disable-two-week-days-instead-of-sunday-and-saturday
				// https://github.com/Pikaday/Pikaday
				// CS: Disables Sunday's (0) and Tuesday's (2)
				return (date.getDay() === 0 || date.getDay() === 2);
			}
		});
	}
}
